/**
 * Normalizes time format to ensure consistent display
 * Converts between single-digit and double-digit formats
 * Examples: "3:00" -> "03:00", "03:00" -> "3:00", "12:00" -> "12:00"
 */
export const normalizeTimeFormat = (time: string): string => {
  if (!time || typeof time !== "string") return time;

  const parts = time.split(":");
  if (parts.length !== 2) return time;

  const [minutes, seconds] = parts;
  const normalizedMinutes = minutes.padStart(2, "0");
  const normalizedSeconds = seconds.padStart(2, "0");

  return `${normalizedMinutes}:${normalizedSeconds}`;
};
